export default {"src":"/_next/static/media/cities.059c9736.svg","height":50,"width":50};